import { Link } from 'react-router-dom';
import { stats } from '@/mocks/home';

export default function HeroBanner() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20atmosphere%20with%20dramatic%20lighting%20and%20energy%2C%20multiple%20sports%20elements%20including%20football%20and%20basketball%20silhouettes%2C%20dark%20moody%20background%20with%20warm%20golden%20accent%20lights%2C%20professional%20sports%20photography%20style%2C%20cinematic%20color%20grading%2C%20epic%20scale%2C%20atmospheric%20depth&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="皇冠体育平台 - 专业体育赛事投注"
          className="w-full h-full object-cover object-top"
          title="皇冠体育官方平台·专业体育赛事投注首选"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-20 md:pt-24 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-500/30 mb-6 md:mb-8">
            <i className="ri-verified-badge-line text-accent-400 text-sm"></i>
            <span className="text-accent-300 text-xs md:text-sm font-medium">亚洲领先体育博彩平台 · 15年专注</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 md:mb-6 leading-tight">
            专业体育赛事投注
            <br />
            <span className="text-accent-400">首选皇冠体育</span>
          </h1>

          <p className="text-foreground-300 text-sm md:text-lg max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
            提供足球、篮球、网球、电竞等全球热门赛事实时赔率，安全稳定、极速到账，享受顶级体育博彩体验
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="#register"
              className="w-full sm:w-auto whitespace-nowrap px-8 py-3 md:px-10 md:py-3.5 rounded-lg bg-accent-500 text-background-50 font-semibold text-sm md:text-base hover:bg-accent-600 transition-all duration-300 cursor-pointer"
            >
              立即注册
            </a>
            <Link
              to="/category/football"
              className="w-full sm:w-auto whitespace-nowrap px-8 py-3 md:px-10 md:py-3.5 rounded-lg border border-background-50/30 text-background-50 font-medium text-sm md:text-base hover:bg-background-50/10 transition-all duration-300 cursor-pointer"
            >
              查看赛事
            </Link>
          </div>

          <div className="mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-3xl mx-auto">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-400 mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}